// extracted by mini-css-extract-plugin
export default {"container":"BlockModal_container__1yWfp","icon":"BlockModal_icon__gur8t","text":"BlockModal_text__3ZIfF"};